/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Visitor_Login_SavedInputs */



/**
* | output |
* | --- |
* | "Visitor sign-in settings saved." |
*
* @param {Artifact_Visitor_Login_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_visitor_login_saved = /** @type {((inputs?: Artifact_Visitor_Login_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Visitor_Login_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen zur Besucher-Anmeldung gespeichert.")
	return /** @type {LocalizedString} */ ("Visitor sign-in settings saved.")
});